"use client";

import { useEffect, useState } from "react";
import type { ProductGetResult } from "@/dao/product";
import { ProductBottomStickyCard } from "./product-sticky-bottom-card";

export const ProductStickyBottom = ({
	product,
	variant,
	currency,
	locale,
	domain,
	theme,
}: Readonly<{
	product: ProductGetResult;
	variant: ProductGetResult["variants"][number] | undefined;
	currency: string;
	locale: string;
	domain: string;
	theme: {
		color?: string | null;
		buttonBackgroundColor?: string | null;
		buttonHoverBackgroundColor?: string | null;
		buttonTextColor?: string | null;
	};
}>) => {
	const [show, setShow] = useState(false);
	useEffect(() => {
		const button = document.getElementById("button-add-to-cart");
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry) {
					setShow(!entry.isIntersecting);
				}
			},
			{ threshold: 0, rootMargin: "-100px 0px 0px 0px" },
		);

		if (button) {
			observer.observe(button);
		}

		return () => {
			if (button) {
				observer.unobserve(button);
			}
		};
	}, []);
	return (
		<ProductBottomStickyCard
			product={product}
			variant={variant}
			currency={currency}
			locale={locale}
			domain={domain}
			theme={theme}
			show={show}
		/>
	);
};
